// extracted by mini-css-extract-plugin
module.exports = {"sorting":"Sorting_sorting__sZ6n5","title":"Sorting_title__2lbY4","table":"Sorting_table__3zWoq","parameter":"Sorting_parameter__3W4f9","_active":"Sorting__active__NboOd"};